<div class="draggable-container d-flex" (click)="calcHeight()" cdkDrag cdkDragBoundary=".wyswyg-editor">
  <div [ngStyle]="{'height': height+'px', 'border': '3px solid var(--white-color)'}" class="drag-handle"
    cdkDragHandle>
    <i class="fas fa-grip-vertical"></i>
  </div>
  <div class="element-wrapper py-2 ps-1" #wrapper>
    <ng-content></ng-content>
  </div>
  <div class="element-toolbar" #elementToolbar>
    <button [disabled]="focusModeActive" (click)="duplicateElement()" class="btn btn-outline-levelab"><i
        class="fa-regular fa-copy nav_icon"></i></button>
    <button (click)="deleteElement()" class="btn btn-outline-danger"><i class="fa-solid fa-trash nav_icon"></i></button>
  </div>
</div>
